module.exports = __webpack_public_path__ + "img/chart-pie-simple.1272e536.svg";